/** CSS contract: css-library/components/03-layouts/prompt.css. */
import type { ComponentProps, Ref } from 'react';
import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../lib/cx';
import { Modal } from './Modal';
import { ModalHead } from './ModalHead';

export interface PromptProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children' | 'role'> {
  topbar?: ReactNode;
  onEscape: () => void;
  busy?: boolean;
  cardClassName?: string;
  cardRole?: 'dialog' | 'alertdialog';
  children?: ReactNode;
}

export function Prompt(
  { ref, topbar, onEscape, busy = false, cardClassName, cardRole = 'dialog', className, children, ...rest }: PromptProps & { ref?: Ref<HTMLDivElement> },
) {
  return (
    <Modal ref={ref} size="compact" onClose={onEscape} busy={busy} role={cardRole}
      overlayClassName={cx('prompt-overlay', className)} className={cx('prompt-card', cardClassName)}
      topbar={topbar ?? <ModalHead onClose={onEscape} closeLabel="Schließen" closeDisabled={busy} />}
      {...rest}>
      {children}
    </Modal>
  );
}

export type PromptActionsProps = ComponentProps<'div'>;

export function PromptActions({ className, ...props }: PromptActionsProps) {
  return <div className={cx('prompt-actions', className)} {...props} />;
}

export type PromptBodyProps = ComponentProps<'div'>;

export function PromptBody({ className, ...props }: PromptBodyProps) {
  return <div className={cx('prompt-body', className)} {...props} />;
}
